import { Tooltip } from 'antd';
import chromeExtensionImageLarge from 'src/assets/download_chrome_extension_large.png';
import chromeExtensionImageSmall from 'src/assets/download_chrome_extension_small.svg';
import { SupaDemo } from '../../components/groupComponents/supaDemo';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const DownloadChromeExtensionSideBanner = ({ isMinimized }) => {
  const isMobileView = window.innerWidth < 1260;
  const { user } = useAuth();

  const handleOpenChromeExtension = () => {
    analytics.track('Clicked On Chrome Extension Web Store Logo', {
      email: user?.email,
    });
    window.open(
      'https://chromewebstore.google.com/detail/aura-ai-scribe/ccblejmmljdcglbnafiodbaekbcpeoep?hl=en',
      '_blank'
    );
  };
  return (
    <div>
      {isMinimized ? (
        <div
          className="flex justify-center"
          onClick={handleOpenChromeExtension}
        >
          <Tooltip title="Download Chrome Extension" placement="rightBottom">
            <img
              src={chromeExtensionImageSmall}
              width=""
              height=""
              className="cursor-pointer h-[40px]"
              alt="Chrome Extension"
            />
          </Tooltip>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center">
          <SupaDemo isMobileView={isMobileView}>
            <p
              data-supademo-demo="cm5yvv1xv0d4ltfatd9w947pt"
              className="cursor-pointer ih-button-ghost gap-2 text-[#5a8dda] underline"
              onClick={() => {
                analytics.track('Clicked Chrome Extension Guided Tour', {
                  email: user?.email,
                });
              }}
            >
              <QuestionCircleOutlined /> Guided Tour
            </p>
          </SupaDemo>

          <img
            className="cursor-pointer h-[55px]"
            src={chromeExtensionImageLarge}
            width=""
            height="55"
            alt="Chrome Extension"
            onClick={handleOpenChromeExtension}
          />
        </div>
      )}
    </div>
  );
};

export default DownloadChromeExtensionSideBanner;
